<template>
  <div>
      <span v-for="e in triggerList"
        :key="e.id"
        :title="JSON.stringify(e)">#{{e.id}} {{e.name}}</span>
  </div>
</template>

<script>
export default {
    name : "WebhookTrigger",

    props : ['value'],

    data() {
        return {
            triggerList : []
        };
    },

    mounted() {
        var _this = this;
        sdk.TicketTriggerApi().listByWebhookId({
            webhookId : _this.value
        }).then(res => {
            _this.triggerList = res;
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/WebhookTrigger.vue